<app-header></app-header>
<!-- ======= Hero Section ======= -->
<section id="hero" class="d-flex flex-column justify-content-end align-items-center">
    <div id="heroCarousel" class="container carousel carousel-fade" data-ride="carousel">

        <!-- Titulo -->
        <div class="carousel-item active">
            <div class="carousel-container" style="height: 100%;">
                <h2 class="mt-4 animate__animated animate__faster animate__fadeInDown" style="margin-bottom: 0px;">
                    Preguntas Frecuentes
                </h2>

                <p class="d-block d-sm-block d-md-none" style="font-size: 0.65rem;margin-bottom: 0px;">Información
                    importante para los Administradores de Quinielas</p>
                <p class="d-none d-sm-none d-md-block" style="margin-bottom: 0px;">Información importante para los
                    Administradores de Quinielas</p>

                <section id="services" class="services" style="padding: 1rem;width: 100%;">
                    <app-loader *ngIf="isLoading"></app-loader>
                    <div *ngIf="!isLoading">

                        <!-- ======= F.A.Q Section ======= -->
                        <section id="faq" class="faq" style="padding: 12px 0;">
                            <div class="container">
                                <ul class="faq-list">

                                    <li data-aos="fade-up" data-aos-delay="100">
                                        <a data-toggle="collapse" class="" href="#faq1">¿Qué es una QUINIELA? <i class="icofont-simple-up"></i></a>
                                        <div id="faq1" class="collapse show" data-parent=".faq-list">
                                            <p>
                                                Juego de apuestas en el cual los participantes rellenan un formulario 
                                                con los pronósticos de los resultados de cierta competición deportiva, enfocado 
                                                especialmente en partidos de fútbol.  En la medida que acierten resultados 
                                                van acumulando puntos, al final el premio se entrega al o a los participantes 
                                                con el mayor puntaje obtenido.
                                             </p>
                                        </div>
                                    </li>

                                    <li data-aos="fade-up" data-aos-delay="200">
                                        <a data-toggle="collapse" href="#faq2" class="collapsed">¿ Con qué finalidad se realiza un QUINIELA? <i
                                                class="icofont-simple-up"></i></a>
                                        <div id="faq2" class="collapse" data-parent=".faq-list">
                                            <p>
                                                El objetivo principal es divertirse entre amigos y conocidos, pero también 
                                                podemos recaudar fondos para alguna acción benéfica que requiera obtener 
                                                ayuda monetaria y en algunos casos para recabar fondos para realizar alguna
                                                compra o reparación comunitaria, ejemplo: reparar canchas deportivas, reparar 
                                                ascensores, etc.
                                            </p>
                                        </div>
                                    </li>

                                    <li data-aos="fade-up" data-aos-delay="300">
                                        <a data-toggle="collapse" href="#faq3" class="collapsed">¿ Cómo puedo participar ? <i
                                                class="icofont-simple-up"></i></a>
                                        <div id="faq3" class="collapse" data-parent=".faq-list">
                                            <p>
                                                Participar es muy sencillo, los organizadosres le enviaran una invitación con 
                                                el link de la QUINIELA, debe llenar el formulario y realizar el pago respectivo.
                                            </p>
                                        </div>
                                    </li>

                                    <li data-aos="fade-up" data-aos-delay="400">
                                        <a data-toggle="collapse" href="#faq4" class="collapsed">¿ Debo revisar los datos de los organizadores y la motivación? <i class="icofont-simple-up"></i></a>
                                        <div id="faq4" class="collapse" data-parent=".faq-list">
                                            <p>
                                                Es importante chequear la información de los organizadores, conocer y tener alguna referencia  de los motivos
                                                para los cuales se está realizando la QUINIELA.
                                            </p>
                                        </div>
                                    </li>

                                    <li data-aos="fade-up" data-aos-delay="500">
                                        <a data-toggle="collapse" href="#faq5" class="collapsed">¿ Cómo obtengo puntos al finalizar cada partido ? <i
                                                class="icofont-simple-up"></i></a>
                                        <div id="faq5" class="collapse" data-parent=".faq-list">
                                            <p>
                                                La puntuación es muy sencilla, por cada partido se pueden obtener máximo 3 puntos.  Si acierta el resultado
                                                exacto, usted se gana 3 puntos; si usted no acierta el resultado pero en sus pronóstico acierta el equipo 
                                                ganador obtiene 1 punto.  Si el resultado queda en EMPATE y usted colocó que terminaria en empate, pero su 
                                                resultado no es el exacto, usted gana solo 1 punto.  En casos de partidos APLAZADOS o SUSPENDIDOS sin 
                                                resultado oficial, se esperará hasta la fecha del último partido de la quiniela, si para ese día
                                                no se ha realizado quedará fuera de la quiniela, sin aportar puntos a ningún participante.
                                            </p>
                                        </div>
                                    </li>

                                    <li data-aos="fade-up" data-aos-delay="600">
                                        <a data-toggle="collapse" href="#faq6" class="collapsed">¿ Cómo se sabe cual será el monto a repartir ? <i
                                                class="icofont-simple-up"></i></a>
                                        <div id="faq6" class="collapse" data-parent=".faq-list">
                                            <p>
                                                Al crear la QUINIELA se le solicita a los organizadores colocar el porcentaje % que está destinado 
                                                a la premiación, este procentaje varía según la motivación de la misma.  En la pagina de forma automática 
                                                se actualiza el monto del premio según aumenta la participación en la QUINIELA.
                                            </p>
                                        </div>
                                    </li>

                                    <li data-aos="fade-up" data-aos-delay="700">
                                        <a data-toggle="collapse" href="#faq7" class="collapsed">¿ Cómo se sabe cuantos puntos llevo acumulado 
                                            y cómo estoy dentro del cuadro de participantes ? <i
                                                class="icofont-simple-up"></i></a>
                                        <div id="faq7" class="collapse" data-parent=".faq-list">
                                            <p>
                                                Después de llenar y pagar la QUINIELA, la página te mostrará el botón VER PUNTUACION.  Al pulsarlo aparecerá en pantalla 
                                                la tabla de puntuación y además una línea para realizar busqueda por nombre, partido, fecha, etc.
                                            </p>
                                        </div>
                                    </li>

                                </ul>

                            </div>
                        </section><!-- End F.A.Q Section -->

                    </div>
                </section><!-- End Services Section -->
            </div>
        </div>
    </div>

    <svg class="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 24 150 28 " preserveAspectRatio="none">
        <defs>
            <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="wave1">
            <use xlink:href="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
        </g>
        <g class="wave2">
            <use xlink:href="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
        </g>
        <g class="wave3">
            <use xlink:href="#wave-path" x="50" y="9" fill="#fff" />
        </g>
    </svg>


</section><!-- End Hero -->